import axiosInstance from "../api.axiosInstance"
import type { UserProfileDto } from "../dto/user.dto"

export class UserService {
  async getProfile(): Promise<UserProfileDto> {
    const response = await axiosInstance.get<UserProfileDto>(`user/v1/profile`)
    return response.data
  }
}

export const userService = new UserService()
